import {MapLayerCategory} from "../layer-registry";

export function addStartAndEndMarkerWithLayer(startCoordinates, endCoordinates) {
  // Remove existing start marker layer and source, if any
  window.layerRegistry.addSource('trail-start', {
    type: 'geojson',
    data: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: startCoordinates
      },
      properties: {}
    }
  })

  window.layerRegistry.addLayer({
    id: 'trail-start',
    type: 'circle',
    source: 'trail-start',
    paint: {
      'circle-radius': 12,
      'circle-color': '#70C381',
      'circle-opacity': 1,
      'circle-stroke-color': '#ffffff',
      'circle-stroke-width': 2,
      'circle-stroke-opacity': 1
    }
  }, MapLayerCategory.Annotations, { z: 12});

  window.layerRegistry.addSource('trail-end', {
    type: 'geojson',
    data: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: endCoordinates
      },
      properties: {}
    }
  });

  window.layerRegistry.addLayer({
    id: 'trail-end',
    type: 'circle',
    source: 'trail-end',
    paint: {
      'circle-radius': 12,
      'circle-color': '#DB2B35',
      'circle-opacity': 1,
      'circle-stroke-color': '#ffffff',
      'circle-stroke-width': 2,
      'circle-stroke-opacity': 1
    }
  }, MapLayerCategory.Annotations, { z: 11});
}

export function removeStartAndEndMarkerWithLayer() {
  window.layerRegistry.removeLayer('trail-start');
  window.layerRegistry.removeLayer('trail-end');
}

